<section class="py-10 text-secondary dark:text-[#F2F2F2] text-sm leading-relaxed">
  <div class="relative z-10 h-[300px] mt-[-8.25rem] bg-[#EFF5FD] dark:bg-primary-dark">
    <div class="absolute inset-0 z-20 flex flex-col gap-4 items-center justify-center mt-10">
      <div class="mt-20 flex flex-col items-center gap-4">
        <app-back />
        <h4 class="text-secondary dark:text-white text-2xl md:text-5xl font-bold">
          {{ "Terms_Conditions.Page_Title" | translate }}
        </h4>

        <h3 class="text-muted dark:text-grey-dark text-xs lg:text-base w-80 md:w-full">
          {{ "Terms_Conditions.Page_Subtitle" | translate }}

          <a routerLink="/contact-us" class="text-brand font-medium">
            {{ "Home_Page.Footer.Contact" | translate }}
          </a>
          {{ "Terms_Conditions.Page_Subtitle_2" | translate }}
        </h3>
      </div>
    </div>
  </div>

  <div class="mt-6 container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <p class="mb-10 text-[18px]">
      {{ "Terms_Conditions.Intro" | translate }}
    </p>

    <ol class="list-decimal pl-5 space-y-4 mt-2 text-[18px]" [ngClass]="{ 'pr-5': isRTL }">
      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_One_Title" | translate }}
        </h2>
        <p>
          {{ "Terms_Conditions.Section_One_Description" | translate }}
        </p>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Two_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Conditions.Section_Two_Point_One" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Two_Point_Two" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Two_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Three_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Conditions.Section_Three_Point_One" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Three_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Four_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Conditions.Section_Four_Point_One" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Four_Point_Two" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Five_Title" | translate }}
        </h2>
        <p>{{ "Terms_Conditions.Section_Five_Description" | translate }}</p>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Six_Title" | translate }}
        </h2>
        <p>{{ "Terms_Conditions.Not_Liable_For" | translate }}</p>
        <ul class="list-disc pl-5 space-y-1">
          <li>{{ "Terms_Conditions.Section_Six_Point_One" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Six_Point_Two" | translate }}</li>
          <li>{{ "Terms_Conditions.Section_Six_Point_Three" | translate }}</li>
        </ul>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Seven_Title" | translate }}
        </h2>
        <p>{{ "Terms_Conditions.Section_Seven_Description" | translate }}</p>
      </li>

      <li>
        <h2 class="font-medium text-md">
          {{ "Terms_Conditions.Section_Nine_Title" | translate }}
        </h2>
        <ul class="list-disc pl-5 space-y-1" [ngClass]="{ 'pr-5': isRTL }">
          <li>{{ "Terms_Conditions.Section_Nine_Point_One" | translate }}</li>
        </ul>
      </li>
    </ol>

    <h4 class="p-2 text-lg">
      {{ "Terms_Conditions.Agreement_Notice" | translate }}
      <a href="mailto:support&#64;dreamnfly.com" class="text-brand font-medium">
        {{ "Terms_Conditions.Email" | translate }}
      </a>
    </h4>
  </div>
</section>